








































import { ref, onMounted, defineComponent } from "@nuxtjs/composition-api";
import { SfLink } from "@storefront-ui/vue";
import relatedSiteData from "~/helpers/data/relatedSiteData";
import { clickOutside } from "~/components/directives/click-outside/click-outside-directive";
import { useGtm } from "~/composables";

export default defineComponent({
  name: "RelatedSite",
  components: {
    SfLink,
  },
  directives: { clickOutside },
  props: {
    outsideClose: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { eventCustomlinksInteracted } = useGtm();
    const isActive = ref(false);
    const relatedSites = ref([]);

    onMounted(() => {
      relatedSites.value = relatedSiteData;
    });
    const closeRelatedSite = () => {
      if (props.outsideClose) {
        isActive.value = false;
      }
    };

    const footerTracking = (label) => {
      eventCustomlinksInteracted({
        "eventlabel": label,
        "eventCategory": "Footer Links",
      });
    };

    return {
      closeRelatedSite,
      isActive,
      relatedSites,
      footerTracking,
      eventCustomlinksInteracted,
    };
  },
});
